const reportingFilterFrequency = [
  { _id: '1', option_name: 'Monthly' },
  { _id: '2', option_name: 'Daily' },
];

export default reportingFilterFrequency;